var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCloseFullscreen48Line = function SvgIconCloseFullscreen48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.311 21.11 7.9-7.9-2.41-2.41-7.9 7.9.14-5.78-3.39-.08-.22 8.77a2.9 2.9 0 0 0 2.9 3h.07l8.77-.21-.08-3.4-5.78.11ZM21.61 23.43l-8.77.22.08 3.4 5.78-.15-7.9 7.9 2.41 2.41 7.9-7.9-.14 5.78 3.39.08.22-8.77a2.898 2.898 0 0 0-.85-2.12 3 3 0 0 0-2.12-.85Z",
    fill: "current"
  })));
};
export default SvgIconCloseFullscreen48Line;